import React from 'react';
import { useNavigate } from 'react-router-dom';
//import logo from '../Images/ringpelogocugpws.png';
import logo from '../Images/ringpelogocugpws.png';
import './Footer.css';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="footer-contact">
          <h3>Contact</h3>
          <div>
            <span className="footer-label">Website</span>
            <a href="https://www.sabadotechnologies.com" target="_blank" rel="noopener noreferrer">
              www.sabadotechnologies.com
            </a>
          </div>
          <div>
            <span className="footer-label">Phone</span>
            <a href="tel:+917411136524">+91 7411136524</a>
          </div>
          <div>
            <span className="footer-label">Email</span>
            <a href="mailto:support@sabadotechnologies.com">support@sabadotechnologies.com</a>
          </div>
        </div>
        <div className="footer-legal">
          <h3>Legal</h3>
          <ul>
            <li>
              <button className="footer-link" onClick={() => navigate('/terms')}>Terms & Conditions</button>
            </li>
            <li>
              <button className="footer-link" onClick={() => navigate('/privacy')}>Privacy Policy</button>
            </li>
            <li>
              <button
                className="footer-link"
                onClick={() => window.open('https://sabadotechnologies.com/', '_blank')}
              >
                About Us
              </button>
            </li>
            <li>
              <button className="footer-link" onClick={() => navigate('/disclaimer')}>Disclaimer</button>
            </li>
          </ul>
        </div>
      </div>
      {/* Add logo at the very end of the footer */}
      <div className="footer-logo-wrapper">
        <img
          src={logo}
          alt="RingPe Logo"
          className="footer-logo"
        />
      </div>
    </footer>
  );
};

export default Footer;